// to namespace this module
import DrupalMailService from '@/services/DrupalMailService.js'
import moment from "moment/moment";
export const namespaced = true

export const state = {
    notifications: [],
    retryCount:0
}

let nextId = 1
export const mutations = {
    PUSH (state, notification) {
        state.notifications.push({
            // use object destructuring to add an id to notification object
            ...notification,
            id: nextId++
        })
    },
    SEND (state, notification) {
        if (notification.sending !== undefined) {
            DrupalMailService.sendError(notification.sending).then(response => {})
        }
    },
    INCREMENTCOUNT(){
        state.retryCount ++;
    },
    DELETE (state, notificationIDToRemove) {
        state.notifications = state.notifications.filter(
            // create array without id to remove object
            notification => notification.id !== notificationIDToRemove
        )
    },
    CLEAR (state) {
        state.notifications = []
    }
}

export const actions = {
    add ({ commit }, notification) {
    // use commit from context object, notification as payload
        commit('PUSH', notification)
        commit('SEND', notification)
    },
    remove ({ commit }, notificationIDToRemove) {
        commit('DELETE', notificationIDToRemove)
    },
    incrementCount ({ commit }) {
        commit('INCREMENTCOUNT')
    },
    clear ({ commit }) {
        commit('CLEAR')
    }
}


export const getters = {
    getRetryCount: state => id => {
        return state.retryCount
    }
}
